import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { changeCustomerSelectCustomerContainerStyles as buttonStyle } from "@tKgpco/Overrides/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(dateRangeStyles, {
    datePickersWrapper: {
        css: css`
            display: flex;
            > div {
                width: 50%;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: block;
                            > div {
                                width: 100%;
                            }
                        `,
                    ],
                    "max",
                )}
        `,
    },
    fromDate: {
        cssOverrides: {
            inputSelect: css`
                width: 100%;
            `,
            formField: css`
                padding-right: 10px;

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding-right: 0;
                            `,
                        ],
                        "max",
                    )}
            `,
            datePicker: css`
                .react-datetime-picker {
                    border-radius: 4px !important;
                    > div > div[class="react-datetime-picker__inputGroup"] {
                        pointer-events: none !important;
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    .react-calendar {
                                        left: 0 !important;
                                    }
                                `,
                            ],
                            "max",
                        )}
                }
            `,
        },
    },
    toDate: {
        cssOverrides: {
            inputSelect: css`
                width: 100%;
            `,
            formField: css`
                padding-left: 10px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding-left: 0;
                                padding-top: 10px;
                            `,
                        ],
                        "max",
                    )}
            `,
            datePicker: css`
                .react-datetime-picker {
                    border-radius: 4px !important;
                    > div > div[class="react-datetime-picker__inputGroup"] {
                        pointer-events: none !important;
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    .react-calendar {
                                        left: 0 !important;
                                    }
                                `,
                            ],
                            "max",
                        )}
                }
            `,
        },
        labelProps: {},
    },
});
